export default {
    copyMigrateModal: {
        title: 'Kopiraj {count} intervala iz {date}',
        source: 'Izvor: {date} (zbroj {sum})',
        selectTargets: 'Odaberite ciljne dane (prikazan je pregled prepisivanja):',
        lengthMismatch: 'Neusklađenost DST duljine — intervali će biti skraćeni ili nadopunjeni',
        overwriteWarning: '{count} odabranih dana ima postojeće izmjene koje će biti prepisane:',
        confirmCopy: 'Potvrdi kopiranje ({count})',
    },
}
